/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientRequest
 */
export interface ClientRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRequest
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the ClientRequest interface.
 */
export function instanceOfClientRequest(value: object): value is ClientRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ClientRequestFromJSON(json: any): ClientRequest {
    return ClientRequestFromJSONTyped(json, false);
}

export function ClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'companyName': json['companyName'],
        'countryCode': json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function ClientRequestToJSON(value?: ClientRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'companyName': value['companyName'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
    };
}

